import { render } from "./ServiceIcon.vue?vue&type=template&id=46c5a9c7&scoped=true"
import script from "./ServiceIcon.vue?vue&type=script&lang=js"
export * from "./ServiceIcon.vue?vue&type=script&lang=js"

import "./ServiceIcon.vue?vue&type=style&index=0&id=46c5a9c7&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c5a9c7"]])

export default __exports__